/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const SupportHeadset = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M5 10.5H4.97222C4.15914 10.5 3.5 11.1591 3.5 11.9722V13.3611C3.5 14.1742 4.15914 15 4.97222 15H6.5V16.5H4.97222C3.33071 16.5 2 15.0026 2 13.3611V11.9722C2 10.3307 3.33071 9 4.97222 9H5.12759C5.72666 5.57745 8.38422 3 12.0166 3C15.649 3 18.281 5.57745 18.8738 9H19.0278C20.6693 9 22 10.3307 22 11.9722V13.3611C22 15.0026 20.6693 16.5 19.0278 16.5H18.5189C18.0088 17.8062 17.1204 18.9236 15.9882 19.7183C15.8795 20.7202 15.0308 21.5 14 21.5C12.8954 21.5 12 20.6046 12 19.5C12 18.3954 12.8954 17.5 14 17.5C14.5993 17.5 15.1371 17.7636 15.5037 18.1813C16.7141 17.1629 17.4831 15.6384 17.4831 13.9346V10.486C17.4831 7.18774 15.321 4.51401 12.0166 4.51401C8.71223 4.51401 6.51685 7.18774 6.51685 10.486V13.5H5V10.5ZM19 13.9346V10.5H19.0278C19.8409 10.5 20.5 11.1591 20.5 11.9722V13.3611C20.5 14.1742 19.8409 15 19.0278 15H18.9201C18.9727 14.6525 19 14.2967 19 13.9346Z"
                        fill={color}
                    />
                </svg>
        );
    };
